export const hotfixExcludingTags = [
    '1826', '1840', '1971', '2096',
];
